import {
  InvalidPDFException,
  MissingPDFException,
  RenderingCancelledException,
  UnexpectedResponseException,
} from 'pdfjs-dist/build/pdf';

const getErrorName = (error) => {
  if (error instanceof InvalidPDFException) {
    return 'InvalidPDFException';
  }

  if (error instanceof MissingPDFException) {
    return 'MissingPDFException';
  }

  if (error instanceof RenderingCancelledException) {
    return 'RenderingCancelledException';
  }

  if (error instanceof UnexpectedResponseException) {
    return 'RenderingCancelledException';
  }

  if (error.message === 'No password given' || error.message === 'Incorrect Password') {
    return 'PasswordException';
  }

  return error.name;
};

export default getErrorName;
